import WorkplaceListbox from "@/components/WorkplaceListbox";
import type { Workplace } from "./types";

type Props = {
  workplaces: Workplace[];
  selectedId: string | null;
  onSelect: (id: string) => void;
};

// "Where do you work?" — thin wrapper around the shared WorkplaceListbox
// (grouped-by-market picker, also used by the admin assign-role dialog).
export default function WorkplaceStep({ workplaces, selectedId, onSelect }: Props) {
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <h2 className="text-base font-semibold text-foreground">Where do you work?</h2>
        <p className="text-sm text-muted-foreground">
          Pick your team or channel — or “Company-wide” if you work across a whole market.
        </p>
      </div>

      <WorkplaceListbox workplaces={workplaces} selectedId={selectedId} onSelect={onSelect} />
    </div>
  );
}
